import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
`;

export const CheckIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const CheckboxLabel = styled.span`
  margin-left: 8px;
  font-size: 16px;
  font-weight: 400px;
  color: ${({ selected }) => (selected ? '#2D6CDF' : '#6C757D')};
`;
